/**
 * StatsGrid Component
 * 
 * Container for StatCard components with responsive grid layout.
 * Typically displays 4 statistics cards in a row.
 */

import React from 'react';

export interface StatsGridProps {
  /** StatCard components */
  children: React.ReactNode;
  /** Number of columns (default: 4) */
  columns?: 3 | 4 | 5;
}

const columnClasses = {
  3: 'grid-cols-1 md:grid-cols-3',
  4: 'grid-cols-1 md:grid-cols-4',
  5: 'grid-cols-1 md:grid-cols-5',
};

export function StatsGrid({ children, columns = 4 }: StatsGridProps) {
  return (
    <div className={`grid ${columnClasses[columns]} gap-4`}>
      {children}
    </div>
  );
}
